import React from 'react';
import { useUser } from '@/providers';
import { Typography, Box } from '@mui/material';
import ConsolidatedBillingUser from './ConsolidatedBillingUser';

const ConsolidatedBillingAdmin = () => {
  const user = useUser();

  return (
    <Box>
      {user.billing_link_requests && (
        <Box sx={{ mb: 4 }}>
          <Typography variant='h5' gutterBottom>
            Pending Consolidated Billing Requests
          </Typography>
          {user.billing_link_requests.map((link_request) => (
            <ConsolidatedBillingUser
              key={link_request.email}
              user={link_request}
              pending
            />
          ))}
        </Box>
      )}
      {user.billing_linked_accounts && (
        <Box>
          <Typography variant='h5' gutterBottom>
            Active Consolidated Billing Links
          </Typography>
          {user.billing_linked_accounts.map((link_request) => (
            <ConsolidatedBillingUser
              key={link_request.email}
              user={link_request}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ConsolidatedBillingAdmin;
